/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ApiKeyType = zod.enum(['test', 'live']);

export type ApiKeyType = zod.input<typeof ApiKeyType>;
export type ApiKeyTypeOutput = zod.output<typeof ApiKeyType>;
